// removed by extract-text-webpack-plugin
module.exports = {"loading":"_2Pfv6LKhF5CJ64HFuc6WDg","loadingVisible":"_3isWKipMx8jzjm1hxEqdlZ","loadingHidden":"_1W4DHsPU8zv4TzuXvHSWDt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/loadingSpinner/loadingSpinnerComponent.scss
// module id = 680
// module chunks = 22